import { makeStyles, Theme } from '@material-ui/core/styles'
import { IStyleProps } from './Interface'

export default makeStyles<Theme, IStyleProps>(theme => ({
  root: {
    color: ({ disabled }) => (disabled ? '#fff' : ''),
    fontSize: 26,
    lineHeight: '35px',
    padding: '0 45px 0 45px',
    flex: '1',
    '&:hover': {
      cursor: ({ disabled }) => (disabled ? 'pointer' : 'cursor')
    },
    '&  *': {
      display: ({ disabled }) => (disabled ? 'inline' : '')
    },
    '& p': {
      padding: 0,
      fontWeight: 500,
      color: theme.palette.common.lightOrange,
      margin: ({ disabled }) => (disabled ? '0 5px 0 0' : '')
    },
    [`& > *:nth-of-type(2n + 1) p`]: {
      color: theme.palette.common.lightBlue
    },
    [`& > *:last-of-type p`]: {
      margin: 0
    },
    [theme.breakpoints.down('xs')]: {
      padding: 30,
      '&  p': {
        fontSize: 18
      }
    }
  },
  freeTextRoot: {
    display: 'flex',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'flex-start'
    }
  },
  inputContainer: {
    flex: 2,
    '&  p': {
      fontWeight: 500,
      '&:hover': {
        background: 'none'
      }
    },
    '& .MuiInputBase-root': {
      borderRadius: 10
    },
    [theme.breakpoints.down('xs')]: {
      marginBottom: 15,
      width: '100%'
    }
  },
  labelContainer: ({ disabled }) => ({
    flex: 1,
    textAlign: 'right',
    justifyContent: 'flex-end',
    display: disabled ? 'inline' : 'flex',
    [theme.breakpoints.down('xs')]: {
      marginBottom: 5,
      width: '100%'
    },
    '& .MuiFormLabel-root': {
      color: '#fff',
      marginRight: disabled ? 5 : 10
    }
  })
}))
